module.exports = __webpack_public_path__ + "img/js.037f2a06.svg";